import { render, staticRenderFns } from "./buyerInformationMobile.vue?vue&type=template&id=4815bcfe&scoped=true"
import script from "./buyerInformationMobile.vue?vue&type=script&lang=js"
export * from "./buyerInformationMobile.vue?vue&type=script&lang=js"
import style0 from "./buyerInformationMobile.vue?vue&type=style&index=0&id=4815bcfe&prod&scoped=true&lang=less"
import style1 from "./buyerInformationMobile.vue?vue&type=style&index=1&id=4815bcfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4815bcfe",
  null
  
)

export default component.exports